import { render, staticRenderFns } from "./FormularioRDM.vue?vue&type=template&id=98589da6&scoped=true"
import script from "./FormularioRDM.vue?vue&type=script&lang=js"
export * from "./FormularioRDM.vue?vue&type=script&lang=js"
import style0 from "./FormularioRDM.vue?vue&type=style&index=0&id=98589da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98589da6",
  null
  
)

export default component.exports